// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__35mlB","colMin":"styles_colMin__2SFYi"};